import Spinner from '../spinner/Spinner';
import Footer from '../footer/Footer';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../assets/styles/TopHeader.css'; // Make sure this path is correct
import bannerImageUrl from '../../assets/images/refund.jpg';
import Arise4uBlackLogo from '../../assets/images/logo/arise logo 95.svg';

const RefundPolicy = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const headerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (window.scrollY > 50) {
          headerRef.current.classList.add('sticky');
        } else {
          headerRef.current.classList.remove('sticky');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* The main container fragment */}
      <>
        <section
          ref={headerRef}
          className="privacy-header-banner"
          style={{ backgroundImage: `url(${bannerImageUrl})` }}
        >
          <div className="privacy-header-content-wrapper">
        

            <section className="privacy-hero-section">
              <h1 className="privacy-hero-title font-bold">Refund Policy</h1>
            </section>
          </div>
        </section>


        <section className='legalpage-container mb-5'>
          <div className='custom-padding-three'>
            <div className='legalpage-contents mt-3 pt-3 mt-md-5'>
              <div>
                <p className='font-medium fs-5 '>
                  This Refund Policy ("Policy") governs the terms and conditions under which fee refunds may or may not be processed for participants of the ARISE FOR YOU™ program ("Program") jointly organized by HCLTech and Pearson ("Organizers").
                </p>
                <p className='font-medium fs-5 '>
                  By enrolling in the ARISE FOR YOU™ Program and submitting payment, you agree to abide by the terms of this Refund Policy in full.
                </p>
              </div>
              <div className='mt-5'>
                <>
                  <h2 className="mb-3 font-bold txt-blue">1.1 GENERAL POLICY</h2>
                  <ul>
                    <li className='font-medium fs-5 '><strong>1.1.1</strong> All payments made towards participation in the ARISE FOR YOU™ Program are non-refundable, non-transferable, and non-adjustable under ordinary circumstances.</li>
                    <li className='font-medium fs-5 '>
                      <strong>1.1.2</strong> The fee covers access to:
                      <ul className='mt-2' style={{listStyleType: 'circle', marginLeft: '20px'}}>
                        <li>ESB Certification (E-learning + Practice + Certification)</li>
                        <li>Evaluation, Mentoring, and Challenge Participation</li>
                        <li>Administrative and Platform Support Services</li>
                      </ul>
                    </li>
                    <li className='font-medium fs-5 '><strong>1.1.3</strong> Participants are advised to carefully review all program-related information, eligibility criteria, and schedules before proceeding with payment.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.2 EXCEPTIONS TO THE NO-REFUND POLICY</h2>
                  <p className='font-medium fs-5'>Refunds may be considered by organizers only under the following valid and unavoidable circumstances:</p>
                  <ul>
                    <li className="font-medium fs-5"><strong>Duplicate Payment:</strong> If a participant has been charged more than once for the same enrollment due to a technical or banking error. The refund amount will be returned only for the duplicate transaction and not for the original payment.</li>
                    <li className="font-medium fs-5"><strong>Program Cancellation:</strong> If the ARISE FOR YOU™ Program is cancelled entirely by the Organizers before commencement without offering an alternative date or format.</li>
                    <li className="font-medium fs-5"><strong>Medical or Force Majeure Situations:</strong> In case of participant incapacitation due to a certified medical emergency, natural disaster, or other force majeure events. Written proof and supporting documents must be submitted. The Organizers retain the sole discretion to accept or reject such refund requests.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.3 CONDITIONS FOR VALID REFUND CLAIMS</h2>
                  <ul>
                    <li className="font-medium fs-5"><strong>1.3.1</strong> All valid refund requests must be submitted in writing to the organizers within 15 working days from the date of the payment or the event giving rise to the refund claim.</li>
                    <li className="font-medium fs-5">
                      <strong>1.3.2</strong> Participants must provide the following details to the organizers:
                      <ul className='mt-2' style={{listStyleType: 'circle', marginLeft: '20px'}}>
                        <li>Full Name, Contact Details, and Enrollment ID</li>
                        <li>Payment Proof (Transaction Reference)</li>
                        <li>Reason for Refund with Supporting Documentation</li>
                      </ul>
                    </li>
                    <li className="font-medium fs-5">
                      <strong>1.3.3</strong> Refund requests must be addressed to:
                      <div className='mt-2' style={{paddingLeft: '20px'}}>
                        <strong>ARISE FOR YOU Program Office</strong><br />
                        Email: <a href="mailto:vinay.swamy@pearson.com">vinay.swamy@pearson.com</a><br />
                        Subject: ARISE FOR YOU™ Refund Request – [Participant Name] [ Registration Number]
                      </div>
                    </li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.4 REFUND PROCESS</h2>
                  <ul>
                    <li className="font-medium fs-5"><strong>1.4.1</strong> Upon receiving a valid refund request, the Organizers will acknowledge receipt within 5 working days and process the claim within 30 working days complete post-verification.</li>
                    <li className="font-medium fs-5"><strong>1.4.2</strong> Approved refunds will be made via the original mode of payment wherever possible or through bank transfer to the participant's registered bank account.</li>
                    <li className="font-medium fs-5"><strong>1.4.3</strong> The Organizers reserve the right to deduct reasonable administrative and processing charges from the refundable amount wherever applicable.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.5 EXCLUSIONS</h2>
                  <ul>
                    <li className="font-medium fs-5">Refund requests made after the program commencement date (except for the exceptions mentioned) will not be entertained.</li>
                    <li className="font-medium fs-5">No refunds will be processed for non-participation, incomplete participation, personal schedule conflicts, dissatisfaction with program content or outcomes, or inability to clear certification exams.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.6 DISCLAIMER</h2>
                  <ul>
                    <li className="font-medium fs-5">The Organizers reserve the right to revise, amend, or modify this Refund Policy without prior notice. Participants are encouraged to review this Policy periodically via the official ARISE FOR YOU™ website.</li>
                  </ul>
                </>
                <>
                  <h2 className="mt-4 mb-3 font-bold txt-blue">1.7 JURISDICTION</h2>
                  <ul>
                    <li className="font-medium fs-5">This Refund Policy shall be governed in accordance with the laws of India. Any disputes arising out of or relating to this policy shall be subject to the exclusive jurisdiction of the courts located in New Delhi.</li>
                  </ul>
                </>
              </div>
            </div>
          </div>
        </section>

        {/* You had this commented out, but I'll leave it here */}
        {/* <Footer /> */}
      </>

      {/* Spinner for loading state */}
      {isLoading && <Spinner />}
    </>
  );
};

export default RefundPolicy;